import clsx from 'clsx';
import ReactMarkdown from 'react-markdown';
import styles from './Markdown.module.scss';
import type { Options } from 'react-markdown';

const Markdown = ({ className, ...restProps }: Options): JSX.Element => {
  return (
    <ReactMarkdown
      {...restProps}
      className={clsx(styles.markdown, className)}
    />
  );
};

export default Markdown;
